import { colors } from '@narvar/hum-constants';
import { css } from 'emotion';

const s = css``;

export default s;
